<script>
  export let message = "Cargando"
</script>

<div class="d-flex justify-content-center">
  <div class="spinner-border text-center" role="status">
    <span class="visually-hidden">{message}...</span>
  </div>
</div>
